<script lang="ts" context="module">
    import Modal, { createModal } from '$components/Modal.svelte';
    import * as t from '$trans';

    export { createModal };
</script>

<script lang="ts">
    import {
        type NewsFeedPostFragment,
        type RelatedFeedPostFragment,
        FeedParticipantFragmentDoc,
    } from '$gql/graphql.js';
    import FeedPostForm from './FeedPostForm.svelte';
    import { participantToInput } from '$lib/utils/participantUtils';
    import { useFragment } from '$gql/fragment-masking.js';
    import { melt } from '@melt-ui/svelte';
    import { getContainer } from '$components/Context/ContainerContext';

    export let post: NewsFeedPostFragment & { relatedPost?: RelatedFeedPostFragment };
    export let modal: ReturnType<typeof createModal>;
    let {
        elements: { title, close },
        states: { open },
    } = modal;

    const { lang } = getContainer();
</script>

<Modal
    contentClass="min-w-[90vw] max-w-[90vw] ls:max-w-[900px] ls:min-w-[600px] overflow-visible"
    dialogClass="p-0 items-start"
    {modal}
>
    <div class="p-5 border-0 text-left">
        <button use:melt={$close} class="close">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 use:melt={$title} class="modal-title m-0 text-18 ls:text-22">
            {t.feed_post.modal_edit_post_title({}, $lang)}
        </h4>
    </div>

    <div class="text-left">
        <FeedPostForm
            {post}
            autoFocus
            initialAuthor={participantToInput(
                useFragment(FeedParticipantFragmentDoc, post.author),
            )}
            on:success={() => ($open = false)}
            sharedPostId={post.relatedPost?.id}
        />
    </div>
</Modal>
